export const claims = {
  // Claim Business Modal
  "claims.modal.title": "Claim this business",
  "claims.modal.close": "Close",
  "claims.modal.verify.title": "Verification",
  "claims.modal.verify.description": "To claim {businessName}, you must verify that you are the owner.",
  "claims.modal.verify.business_email": "Business email:",
  "claims.modal.verify.your_email": "Your email:",
  "claims.modal.verify.not_available": "Not available",
  "claims.modal.verify.email_match_title": "Email Verification",
  "claims.modal.verify.email_match_success": "Your email matches the business email. You can claim this business.",
  "claims.modal.verify.email_match_warning": "Your email does not match the business email. Please use the business professional email or contact support.",
  "claims.modal.verify.cancel": "Cancel",
  "claims.modal.verify.continue": "Continue",
  
  // Confirm Step
  "claims.modal.confirm.title": "Confirm Claim",
  "claims.modal.confirm.description": "By claiming {businessName}, you confirm that you are the owner or an authorized representative of this business. You will have access to the dashboard to manage information, reviews, and messages.",
  "claims.modal.confirm.benefits_title": "Benefits you'll get:",
  "claims.modal.confirm.benefit_manage": "Manage business information",
  "claims.modal.confirm.benefit_reviews": "Respond to customer reviews",
  "claims.modal.confirm.benefit_stats": "Access statistics",
  "claims.modal.confirm.benefit_messages": "Manage messages and requests",
  "claims.modal.confirm.back": "Back",
  "claims.modal.confirm.submit": "Confirm Claim",
  "claims.modal.confirm.submitting": "Submitting...",
  
  // Success Step
  "claims.modal.success.title": "Request Submitted!",
  "claims.modal.success.description": "Your claim request for {businessName} has been submitted. Our team will verify your information and you will receive a confirmation email.",
  "claims.modal.success.close": "Close",
  
  // Admin Claims Management
  "claims.admin.title": "Supplier Claims",
  "claims.admin.subtitle": "Manage business ownership requests",
  "claims.admin.pending_count": "{count} pending",
  "claims.admin.table.business": "Business",
  "claims.admin.table.claimant": "Claimant",
  "claims.admin.table.business_email": "Business Email",
  "claims.admin.table.date": "Date",
  "claims.admin.table.status": "Status",
  "claims.admin.table.actions": "Actions",
  "claims.admin.status.pending": "Pending",
  "claims.admin.status.approved": "Approved",
  "claims.admin.status.rejected": "Rejected",
  "claims.admin.no_claims": "No pending claim requests",
  "claims.admin.no_claims_icon": "All caught up",
  "claims.admin.view_details": "View details",
  
  // Claim Detail Modal
  "claims.detail.title": "Claim Details",
  "claims.detail.close": "Close",
  "claims.detail.business_info": "Business",
  "claims.detail.business_name": "Name:",
  "claims.detail.business_email_label": "Email:",
  "claims.detail.business_phone": "Phone:",
  "claims.detail.business_address": "Address:",
  "claims.detail.business_location": "Location:",
  "claims.detail.claimant_info": "Claimant",
  "claims.detail.claimant_name": "Name:",
  "claims.detail.claimant_email": "Email:",
  "claims.detail.claimant_date": "Date:",
  "claims.detail.email_verification": "Email Verification",
  "claims.detail.email_match": "Emails match perfectly",
  "claims.detail.email_mismatch": "Emails do not match. Manual verification required.",
  "claims.detail.notes.label": "Notes (optional)",
  "claims.detail.notes.placeholder": "Add notes about this decision...",
  "claims.detail.cancel": "Cancel",
  "claims.detail.reject": "Reject",
  "claims.detail.approve": "Approve",
  "claims.detail.not_available": "N/A",
  
  // Notifications
  "claims.notification.approved_title": "Congratulations! Your profile is approved",
  "claims.notification.approved_message": "Your business \"{businessName}\" has been validated by our team. You can now receive orders.",
  "claims.notification.claim_approved": "Claim approved successfully",
  "claims.notification.claim_rejected": "Claim rejected",
  "claims.notification.claim_submitted": "Your claim request has been submitted successfully",
  "claims.notification.error_submit": "Error submitting the claim request",
  "claims.notification.error_approve": "Error during approval",
  "claims.notification.error_reject": "Error during rejection",
  
  // Sidebar
  "claims.sidebar.menu": "Claims",
  "claims.sidebar.page_title": "Supplier Claims",
  
  // Supplier Page Button
  "claims.supplier.button": "Do you own this business?",
  
  // Errors
  "claims.error.unauthorized": "Unauthorized",
  "claims.error.user_not_found": "User not found",
  "claims.error.supplier_not_found": "Supplier not found",
  "claims.error.already_claimed": "This business has already been claimed",
  "claims.error.claim_not_found": "Claim request not found",
  "claims.error.already_processed": "This request has already been processed",
  "claims.error.admin_only": "Access denied. Only administrators can perform this action.",
};

export default claims;
